import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-semantic-toasts";
import { Header, Segment, Button, List, ListItem, ListIcon, ListContent } from "semantic-ui-react";
import { buildCustomerInviteLink } from "utilities/dist/customer/helpers";
import config from "utilities/dist/config";

export const OrderSystemDetailsContainer = () => {
    let link = buildCustomerInviteLink({
        protocol: config.protocol,
        subDomain: config.order_app_subdomain,
        domain: config.client_host,
    });

    return (
        <>
            <Header
                subheader="Details about your online ordering system"
                content="Online Order System"
                attached="top"
                as="h3"
            />
            <Segment attached>
                <p>
                    Through the online ordering system feature, your customers can directly place
                    orders from your store.
                </p>
                <p>Here are a few helpful links to configure online ordering experience:</p>
                <List>
                    <ListItem>
                        <ListIcon name="cart" />
                        <ListContent>
                            <Link to="/order">View all orders</Link>
                        </ListContent>
                    </ListItem>
                    <ListItem>
                        <ListIcon name="bell" />
                        <ListContent>
                            <Link to="/notification">Manage order related notifications</Link>
                        </ListContent>
                    </ListItem>
                    <ListItem>
                        <ListIcon name="users" />
                        <ListContent>
                            <Link to="/customer/users">
                                View all customers who registered to use online ordering
                            </Link>
                        </ListContent>
                    </ListItem>
                    <ListItem>
                        <ListIcon name="external" />
                        <ListContent>
                            <a href={link} rel="noopener noreferrer" target="_blank">
                                Check out your online ordering website
                            </a>
                        </ListContent>
                    </ListItem>
                </List>
            </Segment>
            <Button
                icon="cart arrow down"
                content="Copy Order System Link"
                attached="bottom"
                onClick={() => {
                    navigator.clipboard.writeText(link);
                    toast({
                        description: `Link to your online ordering system ${link}`,
                        time: 1000,
                        type: "success",
                        icon: "checkmark",
                        title: "Copied to clipboard",
                    });
                }}
            />
        </>
    );
};
